<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :items="data.record"
      :items-per-page="itemsPerPage"
      :no-data-text="$t('common.noRecords')"
      :loading="loading"
      :loading-text="loading ? $t('common.loading') : ''"
      :single-expand="true"
      :expanded.sync="expanded"
      :show-expand="showExpand"
      mobile-breakpoint="0"
      @item-expanded="itemExpanded"
      @update:page="pageChg"
      @update:items-per-page="itemsPerPageChg"
    >
      <template v-slot:item.created="{ item }">
        {{ setTimeZone(item.created) }}
      </template>
      <template v-slot:item.symbol="{ item }">
        {{ processPairDisplayLabel(item.symbol) }}
      </template>
      <template v-slot:item.category="{ item }">
        {{ $t('map.orderCategory')[item.category] }}
      </template>
      <template v-slot:item.orderType="{ item }">
        {{ $t('map.orderType')[item.orderType] }}
      </template>
      <template v-slot:item.volume="{ item }">
        {{ convertDecimal(item.dealVolume, getPrecisionByPair(item.symbol, 2)) }} /
        {{ convertDecimal(item.volume, getPrecisionByPair(item.symbol, 2)) }}
      </template>
      <template v-slot:item.price="{ item }">
        {{ convertDecimal(item.price, getPrecisionByPair(item.symbol, 1)) }} /
        {{ item.dealAmount / item.dealVolume ? convertDecimal(item.dealAmount / item.dealVolume, 8) : '-' }}
      </template>
      <template v-slot:item.dealAmount="{ item }">
        {{ convertDecimal(item.dealAmount, 8) }}
      </template>
      <template v-slot:item.status="{ item }">
        {{ $t('map.myOrderStatus')[item.status] }}
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td class="expand-table-wrap" :colspan="headers.length">
          <v-data-table
            :headers="tradeDetail.columns"
            :no-data-text="$t('common.noRecords')"
            :items="tradeDetail.data"
            mobile-breakpoint="0"
            hide-default-footer
          >
            <template v-slot:item.created="{ item }">
              {{ setTimeZone(item.created) }}
            </template>
          </v-data-table>
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
  import { mapGetters } from 'vuex';
  import tradeMixin from '@/common/mixin/tradeMixin';
  import { tradeApi } from '@/api/exchange.page';
  import { getterTypes } from '@/store/getter-types';
  import Big from 'big.js';

  Big.RM = 0 /* ROUND_DOWN */;

  export default {
    props: {
      coinId: {
        type: [String, Number],
        default: ''
      },
      coinList: {
        type: Array,
        default: () => {
          return [];
        }
      },
      data: {
        type: Object,
        default: () => {
          return {};
        }
      },
      loading: {
        type: Boolean,
        default: false,
      }
      // paginationConfig: {
      //   type: Object,
      //   default: () => {
      //     return {};
      //   }
      // },
    },
    mixins: [tradeMixin],
    computed: {
      ...mapGetters([getterTypes.Getter_Current_Market, getterTypes.Getter_Market_List]),
      localCoinId: {
        get() {
          return this.coinId;
        },
        set(val) {
          this.$emit('update:coinId', val);
        }
      }
    },
    data() {
      return {
        search: '',
        itemsPerPage: 5,
        showExpand: true,
        expanded: [],
        headers: [
          { text: this.$t('labels.date'), value: 'created', width: '160', sortable: false },
          { text: this.$t('labels.orderId'), value: 'id', width: '130', sortable: false },
          { text: this.$t('labels.trade.pair'), value: 'symbol', width: '100', sortable: false },
          { text: this.$t('labels.trade.side'), value: 'category', width: '80', sortable: false },
          { text: this.$t('labels.trade.type'), value: 'orderType', width: '80', sortable: false },
          {
            text: this.$t('labels.trade.dealVol') + ' / ' + this.$t('labels.trade.vol'),
            value: 'volume',
            width: '200',
            sortable: false,
            align: 'center',
          },
          {
            text: this.$t('labels.trade.price') + ' / ' + this.$t('labels.trade.avgPrice'),
            value: 'price',
            width: '200',
            sortable: false,
            align: 'center',
          },
          { text: this.$t('labels.trade.dealAmt'), value: 'dealAmount', width: '150', sortable: false },
          { text: this.$t('labels.status'), value: 'status', width: '80', sortable: false },
          { text: '', value: 'data-table-expand' }
        ],
        tradeDetail: {
          data: [],
          columns: [
            { text: this.$t('labels.date'), value: 'created', width: '160', sortable: false },
            { text: this.$t('labels.orderId'), value: 'id', width: '130', sortable: false },
            { text: this.$t('labels.trade.pair'), value: 'symbol', width: '130', sortable: false },
            { text: this.$t('labels.trade.orderPrice'), value: 'price', width: '130', sortable: false },
            { text: this.$t('labels.trade.orderVol'), value: 'vol', width: '130', sortable: false },
            { text: this.$t('labels.trade.dealAmt'), value: 'amount', width: '150', sortable: false },
            { text: this.$t('labels.trade.fee'), value: 'origFee', width: '130', sortable: false },
            { text: this.$t('labels.trade.paidFee'), value: 'fee', width: '130', sortable: false },
            { text: this.$t('labels.trade.resultAmt'), value: 'resultAmt', width: '130', sortable: false },
          ]
        },
        coinDetail: {}
      };
    },
    methods: {
      pageChg(val) {
        // Close the expanded item
        this.expanded = [];
      },
      itemsPerPageChg(val) {
        // Close the expanded item
        this.expanded = [];
      },
      itemExpanded(data) {
        this.tradeDetail.data = [];
        this.clickTradeDetail(data.item);
      },
      clickTradeDetail(data) {
        let coinDetail = { coinFeeAndActualReceived: '-', executedAmtSymbol: '-' };
        if (!this.isUndefinedOrNullOrEmpty(this.Getter_Market_List[data.symbol])) {
          this.coinDetail = this.Getter_Market_List[data.symbol];
        }
        if (data) {
          if (data.category == 1) {
            data.buyOrderId = data.id;
          } else {
            data.sellOrderId = data.id;
          }

          coinDetail.executedAmtSymbol = this.coinDetail.marketCoin || '-';
          if (data.category == 1) {
            coinDetail.coinFeeAndActualReceived = this.coinDetail.coin || '-';
          }else {
            coinDetail.coinFeeAndActualReceived = this.coinDetail.marketCoin || '-';
          }

          tradeApi.getTradeDetail(data).then(res => {
            this.tradeDetail.data = res.data.record.map(item => {
              if (!this.isUndefinedOrNullOrEmpty(item.fee) && !this.isUndefinedOrNullOrEmpty(item.rebate)) {
                item.origFee = `${new Big(item.fee).plus(new Big(item.rebate)).toFixed(8)} ${coinDetail.coinFeeAndActualReceived}`;
              } else {
                item.origFee = '-';
              }
              if (!this.isUndefinedOrNullOrEmpty(item.amount)
                && !this.isUndefinedOrNullOrEmpty(item.vol)
                && !this.isUndefinedOrNullOrEmpty(item.fee)) {
                if (data.category == 1) {
                  item.resultAmt = `${new Big(item.vol).minus(new Big(item.fee)).toFixed(8)} ${coinDetail.coinFeeAndActualReceived}`;
                } else if (data.category == 2) {
                  item.resultAmt = `${new Big(item.amount).minus(new Big(item.fee)).toFixed(8)} ${coinDetail.coinFeeAndActualReceived}`;
                } else {
                  item.resultAmt = '-';
                }
              }
              item.amount = `${this.convertDecimal(item.amount, this.Getter_Current_Market.priceDec + this.Getter_Current_Market.volDec)} ${coinDetail.executedAmtSymbol}`;
              item.fee = `${this.convertDecimal(item.fee, 8)} ${coinDetail.coinFeeAndActualReceived}`;
              return item;
            });
          });
        }
      }
    }
  };
</script>
<style lang="stylus" scoped>
  .v-data-table::v-deep {
    tbody {
      td {
        font-size: 0.8rem;
      }
    }
  }

  .expand-table-wrap {
    padding: 15px 30px;
  }

  .v-select.select-wrap::v-deep {
    .v-input__control {
      .v-input__slot {
        margin-bottom: 0;
        min-height: 35px;

        .v-select__selections {
          .v-select__selection {
            font-size: 0.85rem;
            max-width: 100%;
          }

          input {
            display: none;
          }
        }

        .v-input__append-inner {
          margin-top: 5px;
        }
      }

      .v-text-field__details {
        display: none;
      }
    }
  }
</style>
